import { Selector, createSelector } from 'reselect';
import { SessionManagementService } from '../../search/services/SessionManagementService';
import { AppUrls } from '../AppUrls';
import { AppState } from '../state/AppState';

export const queryStringSelector = (): string => window.location.search;

export const appUrlsSelector: Selector<AppState, AppUrls> = createSelector(
  queryStringSelector,
  // Some code, including populateContentBreadcrumbs, expect SpacesSiteUrls to be falsy
  // when there's no session (and hence no session site).  This preserves that behavior.
  (queryString) => {
    return new AppUrls({ siteUrlName: SessionManagementService.instance.sessionSiteUrlName(), queryString });
  }
);
